import { State } from '../../../store/state';
import { LocationReportState } from './reducer';

export const locationReportSelector = (state: State): LocationReportState =>
    state.locationReport; 